import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Baseline: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 20h16' }],
    ['path', { d: 'm6 16 6-12 6 12' }],
    ['path', { d: 'M8 12h8' }],
  ],
];

export default Baseline;
